export const statusCodes = {
    ok: 200,
    error: 404,
    token: 412,
    tokenExpire:405
}

export const commonMessage = {
    networkError: 'Network Error'
}

export const capitalizeFirstLetter=(str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
}